module.exports = __webpack_public_path__ + "static/media/1-1.5481939e.png";